import React from 'react';
import TableHeader from './TableHeader';
import {
  Box,
  Paper,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow
} from '@mui/material';

const TableSkeleton = ({ columns = [], sortConfig, handleSort, pageSize = 10 }) => {
  // Ensure columns is an array and has a default fallback
  const safeColumns = Array.isArray(columns) ? columns : [];
  const columnsCount = safeColumns.length > 0 ? safeColumns.length : 5; // Default to 5 columns if none provided

  return (
    <Box sx={{ width: '100%', border: '1px solid', borderColor: 'divider', borderRadius: 2, overflow: 'hidden' }}>
      <TableContainer component={Paper}>
        <Table>
          <TableHeader
            columns={safeColumns}
            sortConfig={sortConfig}
            onSort={handleSort}
          />
          <TableBody>
            {Array(pageSize)
              .fill(0)
              .map((_, index) => (
                <TableRow key={index}>
                  {Array.from({ length: columnsCount })
                    .fill(0)
                    .map((column, columnIndex) => (
                      <TableCell
                        // sx={{ width: column.width || "100%" }}
                        key={columnIndex}
                      >
                        <Skeleton animation="wave" />
                      </TableCell>
                    ))}
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default TableSkeleton;
